import { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { ProjectsData } from "./ProjectSwiperData";

const ProjectSwiper = () => {
  const [projects] = useState(ProjectsData);
  const swiperRef = useRef(null);

  return (
    <>
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        loop
        autoplay={{
          delay: 8000,
          disableOnInteraction: false,
        }}
        slidesPerView="auto"
        spaceBetween={30}
        breakpoints={{
          320: { spaceBetween: 0, slidesPerView: 1 },
          640: { spaceBetween: 10, slidesPerView: 2 },
          920: { spaceBetween: 20, slidesPerView: 3 },
          1300: { spaceBetween: 20, slidesPerView: 4 },
          1920: { spaceBetween: 30, slidesPerView: 5 },
        }}
        modules={[Autoplay]}
        className="mySwiper"
      >
        {projects.map((project, projectIndex) => (
          <SwiperSlide key={projectIndex}>
            <p className="text-center font-[Jost] text-lg font-medium text-gray-700 px-4">
              {project.title}
            </p>
            <div className="bg-[#fff6e2] h-80 flex items-center justify-center bg-gray-200 rounded-lg flex-col">
              <p className=" font-[Jost] text-lg text-gray-700 px-4">
                {project.description}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      {/* Boutons de navigation placés au-dessus du swiper */}
      <div className="flex justify-center gap-4 mb-6 px-4">
        <button
          onClick={() => swiperRef.current?.slidePrev()}
          className="p-3 bg-gray-200 hover:bg-gray-300 rounded-full transition"
          aria-label="Précédent"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <button
          onClick={() => swiperRef.current?.slideNext()}
          className="p-3 bg-gray-200 hover:bg-gray-300 rounded-full transition"
          aria-label="Suivant"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </>
  );
};

export default ProjectSwiper;
